import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(0);

  // const faqs = [
  //   {
  //     question: "What is ANNA OKWARA Foundation?",
  //     answer:
  //       "The ANNA OKWARA Foundation is a climate-focused organization that empowers women’s groups and youth by providing hands-on training in sustainable, climate-smart agriculture through community-based hubs. Its model centers on building local capacity with practical skills that improve farm productivity, lower emissions, and can be applied independently by participants, while also supporting job creation, food security, and long-term environmental sustainability."
  //   },
  //   {
  //     question: "How does the foundation create impact?",
  //     answer:
  //       "The ANNA Foundation creates impact by working with women’s groups and youth in communities to teach climate-smart agricultural practices that reduce emissions and increase productivity. These practical, low-cost methods are designed to be easily replicated on participants’ own farms, enabling widespread adoption. As a result, the approach improves livelihoods, strengthens food security, and contributes to the restoration of degraded agricultural lands."
  //   },
  //   {
  //     question: "What problem is the ANNA OKWARA Foundation trying to solve?",
  //     answer:
  //       "The ANNA OKWARA Foundation addresses the interconnected challenges of climate change, land degradation, food insecurity, and limited livelihood opportunities in vulnerable communities. These challenges are most severe for women and youth who are often excluded from productive economic systems."
  //   },
  //   {
  //     question: "How does the ANNA OKWARAFoundation’s model work in practice?",
  //     answer:
  //       "The Foundation works by establishing community-owned climate hubs that integrate sustainable agriculture, ecosystem restoration, renewable energy, water management, and skills development. Each hub is designed to be locally managed, scalable, and focused on delivering measurable environmental and economic outcomes."
  //   },
  //       {
  //     question: "Who benefits from the ANNA OKWARA Foundation’s initiatives?",
  //     answer:
  //       "The primary beneficiaries are rural communities, with a strong focus on women, youth, and smallholder farmers. These groups gain access to productive land use, skills training, sustainable livelihoods, and income-generating opportunities linked to climate-smart agriculture and green value chains."
  //   }
  //   ,
  //       {
  //     question: "What makes the ANNA OKWARA Foundation’s approach different from other climate or agriculture programs?",
  //     answer:
  //       "The ANNA OKWARA Foundation stands out for its integrated and community-owned model that combines environmental restoration with economic empowerment. Instead of isolated interventions, it builds connected, measurable, and scalable local systems that deliver both climate impact and sustainable livelihoods."
  //   }
  // ];



    const faqs = [
    {
      question: "What does my donation support?",
      answer:
        "Your donation directly supports climate-smart agriculture, women and youth training programs, environmental sustainability initiatives, and livelihood development projects implemented at community level."
    },
    {
      question: "How is impact measured?",
      answer:
        "We use a structured monitoring and evaluation system that tracks environmental, social, and economic outcomes such as hectares restored, people trained, emissions reduced, and livelihoods created. All results are evidence-based and periodically reviewed."
    },
    {
      question: "Is my donation tax-deductible?",
      answer:
        "Where applicable, donations are processed through registered non-profit frameworks and may qualify for tax benefits depending on donor jurisdiction and applicable regulations."
    },
    {
      question: "How do you ensure transparency and accountability?",
      answer:
        "We maintain transparent reporting systems, partner oversight, and impact tracking mechanisms that ensure funds are used strictly for program delivery and measurable outcomes."
    },
        {
      question: "Can I sponsor a specific project or community?",
      answer:
        "Yes. Donors and partners can sponsor specific programs such as farmer training, youth empowerment initiatives, or climate-smart agriculture projects depending on funding priorities."
    }
    ,
        {
      question: "Do you work with international partners?",
      answer:
        "Yes. We collaborate with development agencies, private sector partners, NGOs, and institutions to scale climate-smart solutions and expand impact across communities."
    },


     {
      question: "How often will I receive updates on impact?",
      answer:
        "Donors receive periodic impact updates, including program reports, outcome summaries, and field-level progress where applicable."
    },



     {
      question: "Can individuals or organizations partner with the Foundation?",
      answer:
        "Yes. We welcome strategic partnerships focused on funding, implementation, research, and scaling of climate resilience initiatives."
    },
  ];




  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 120,
      easing: "ease-out-cubic",
    });
  }, []);

  return (
    <section className="bg-[#F7F4EE] py-14 lg:py-24 px-6 md:px-16">

      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-16 items-start">

        {/* LEFT CONTEXT PANEL */}
        <div data-aos="fade-right">

          <p className="text-xs tracking-[0.35em] text-green-400 uppercase mb-6">
            FAQ
          </p>

                     <h2 className="text-3xl md:text-5xl lg:text-5xl font-semibold text-[#2E2A24] leading-tight"       data-aos="fade-up"
            data-aos-delay="100"
            >

            Questions about our
            <span className="block text-green-400">mission</span>
          </h2>

          <p
            data-aos="fade-up"
            data-aos-delay="200"
            className="mt-6 text-[#5C5548] leading-relaxed"
          >
            This section explains how ANNA OKWARA Foundation operates, how impact is created,
            and how individuals and organizations can participate in building
            climate-smart communities.
          </p>

        </div>

        {/* RIGHT ACCORDION */}
        <div className="space-y-6" data-aos="fade-left">

          {faqs.map((item, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={index}
                data-aos="fade-up"
                data-aos-delay={index * 100}
                className="border-b border-[#E7E0D6] pb-5"
              >

                <button
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="w-full flex justify-between items-start text-left group"
                >
                  <span className="text-ms lg:text-lg font-medium text-[#2E2A24] group-hover:text-green-400 transition">
                    {item.question}
                  </span>

                  <span className="text-green-400 text-xl ml-6">
                    {isOpen ? "−" : "+"}
                  </span>
                </button>

                <div
                  className={`overflow-hidden transition-all duration-500 ${
                    isOpen ? "max-h-40 mt-4 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <p className="text-[#5C5548] leading-relaxed text-sm">
                    {item.answer}
                  </p>
                </div>

              </div>
            );
          })}

        </div>

      </div>
    </section>
  );
}